module.exports = __webpack_public_path__ + "static/media/bieres_01_thumb.ed643f99.png";